import { render, staticRenderFns } from "./settingType.vue?vue&type=template&id=080977bb&scoped=true&"
import script from "./settingType.vue?vue&type=script&lang=js&"
export * from "./settingType.vue?vue&type=script&lang=js&"
import style0 from "./settingType.vue?vue&type=style&index=0&id=080977bb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080977bb",
  null
  
)

export default component.exports